export default __webpack_public_path__ + "static/media/arrow.ee444460.svg";